/** 
* 自动生成文件，请勿修改 
* @name: 考核:员工月度/年度/晋升考核表-考核维度配置
* @description: 员工月度/年度/晋升考核表-考核维度配置（三期新增）
* @create: 2024/1/11 下午4:25:21
* @swagger: 2.0
* 合计:7条
*/ 
 
import APIObject from "../utils/APIObject.js" 
const dimensionConf = { 
	/** 1 summary:删除-批量	method:post */ 
	batchDelete : new APIObject("/api/dimensionConf/batchDelete.do"), 
	/** 2 summary:保存/修改-单条	method:post */ 
	saveOrUpd : new APIObject("/api/dimensionConf/saveOrUpd.do"), 
	/** 3 summary:查询-分页(根据name,roleState)	method:post */ 
	queryPage : new APIObject("/api/dimensionConf/queryPage.do"), 
	/** 4 summary:查询-单条(根据主键)	method:post */ 
	queryOne : new APIObject("/api/dimensionConf/queryOne.do"), 
	/** 5 summary:保存/修改-批量	method:post */ 
	batchSaveOrUpd : new APIObject("/api/dimensionConf/batchSaveOrUpd.do"), 
	/** 6 summary:查询-全部不分页	method:post */ 
	queryAll : new APIObject("/api/dimensionConf/queryAll.do"), 
	/** 7 summary:删除-单条	method:post */ 
	delete : new APIObject("/api/dimensionConf/delete.do"), 
};
export default dimensionConf;